// extracted by mini-css-extract-plugin
export var cover = "cover-module--cover--tfzIi";
export var coverImage = "cover-module--coverImage--5AvW9";